import { type FC } from 'react'

import { type AlgoliaRecord } from '../../../algolia'
import { ProductPicture } from '../../../product'
import { urlGetRelativeUrl } from '../../../url-handling'

import { StoryblokProductBatteryProductImageDiscount } from './StoryblokProductBatteryImageDiscount'
import { StoryblokProductBatteryLink } from './StoryblokProductBatteryLink'

type ProductBatteryImageProps = {
  product: AlgoliaRecord
}

export const StoryblokProductBatteryProductImage: FC<
  ProductBatteryImageProps
> = ({ product }) => {
  return (
    <StoryblokProductBatteryLink
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      className="relative px-7 py-3.5 after:absolute after:inset-0 after:bg-gradient-radial after:from-transparent after:via-transparent after:to-[var(--background-light-primary-medium)] tablet:p-3.5"
      data-qa-id={`form-product-slider-${product.id}-image-button`}
      href={urlGetRelativeUrl(product.deeplink) ?? '/'}
    >
      <div
        // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
        className="flex aspect-square max-h-[130px] w-full items-center justify-center"
      >
        <ProductPicture
          imageProps={{
            alt: product.productName,
            height: 130,
            src: product.image,
            width: 130,
          }}
        />
      </div>
      <StoryblokProductBatteryProductImageDiscount product={product} />
    </StoryblokProductBatteryLink>
  )
}
